import { ButtonHTMLAttributes, forwardRef, ReactNode } from 'react';

import clsx from 'clsx';

import styles from '../Carousel.module.css';

export type CarouselButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
	children: ReactNode;
};

export const CarouselButton = forwardRef<HTMLButtonElement, CarouselButtonProps>(({ children, className, ...props }, ref) => {
	return (
		<button
			ref={ref}
			className={clsx(styles.carouselButton, className)}
			{...props}
		>
			{children}
		</button>
	);
});

CarouselButton.displayName = 'CarouselButton';
